import { Routes } from '@angular/router';
import { AppShellComponent } from './shared/layout/app-shell/app-shell.component';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES) },
  // Destino de redirectUrl que arma el backend para el checkout de Wompi — vive fuera del
  // shell autenticado a propósito: el regreso desde un dominio externo implica una recarga
  // completa de la SPA, así que no puede depender del authGuard/estado en memoria de esa
  // sesión previa (ver SubscriptionCallbackPageComponent).
  {
    path: 'subscription/callback',
    loadComponent: () =>
      import('./features/plan/pages/subscription-callback-page.component').then((m) => m.SubscriptionCallbackPageComponent),
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES) },
      { path: 'catalog', loadChildren: () => import('./features/catalog/catalog.routes').then((m) => m.CATALOG_ROUTES) },
      { path: 'orders', loadChildren: () => import('./features/orders/orders.routes').then((m) => m.ORDERS_ROUTES) },
      {
        path: 'messages',
        loadChildren: () => import('./features/messages/messages.routes').then((m) => m.MESSAGES_ROUTES),
        canMatch: [permissionGuard('view_messages')],
      },
      // Primer uso real de permissionGuard en canMatch (CLAUDE.md §7) — a diferencia de
      // dashboard/catalog/orders (permiso por acción, no por página), acá TODOS los endpoints
      // reales de reports piden view_reports por igual, así que gatear la ruta completa no le
      // esconde a nadie una sub-sección que sí podría ver.
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
        canMatch: [permissionGuard('view_reports')],
      },
      { path: 'plan', loadChildren: () => import('./features/plan/plan.routes').then((m) => m.PLAN_ROUTES) },
      // Mismo criterio que 'reports' arriba: identidad/bot-config/whatsapp piden manage_bot por
      // igual en todo settings.html (solo "Métodos de Pago" es mock puro, sin permiso). El nav
      // item de 'config' en nav-items.ts queda sin `permission` a propósito (comentario ahí) —
      // eso solo controla si el link se OCULTA en el sidebar, no si la ruta es alcanzable; este
      // guard sigue aplicando aunque el link siga visible para todos.
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canMatch: [permissionGuard('manage_bot')],
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },
];
